import useAttendanceScan, {
    ATTENDANCE_ACTIONS,
    ATTENDANCE_SCAN_STATES
} from "./use-attendance-scan";
import useAttendanceMutationScan from "./attendance-use-mutation-scan";
import useAttendanceSession from "./use-attendance-session";


const AttendanceHooks = {
    useScan: useAttendanceScan,
    useMutationScan: useAttendanceMutationScan,
    useSession: useAttendanceSession
};

export {
    ATTENDANCE_ACTIONS,
    ATTENDANCE_SCAN_STATES,
    useAttendanceScan,
    useAttendanceMutationScan,
    useAttendanceSession
};

export default AttendanceHooks;
